module.exports = __webpack_public_path__ + "img/article-icon-106.3cc0bc45.svg";